import { render } from "./accordion-radio.vue?vue&type=template&id=16a35716&scoped=true&lang=pug"
import script from "./accordion-radio.vue?vue&type=script&lang=js"
export * from "./accordion-radio.vue?vue&type=script&lang=js"

import "./accordion-radio.vue?vue&type=style&index=0&id=16a35716&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a35716"]])

export default __exports__